const api = 'https://fx.anxincloud.cn';
const domain = 'https://fx.anxincloud.cn';

const devApi = 'https://121.36.37.70:8204';
const devDomain = 'https://121.36.37.70:8204';

const online = false; //是否线上模式

export default {
  domain: online ? domain : devDomain,
  api: online ? api : devApi
}